import 'css-chunk:src/app/components/ApplicationPageTemplates/QuickTemplate/Intro/Intro.scss';export default {
  "Intro": "_Intro_171yt_1",
  "title": "_title_171yt_1",
  "text": "_text_171yt_14",
  "subtitle": "_subtitle_171yt_21"
};